"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_popper_1 = require("react-popper");
var react_beautiful_dnd_1 = require("react-beautiful-dnd");
var useClickOutside_1 = __importDefault(require("../hooks/useClickOutside"));
var Icon_1 = __importDefault(require("./Icon"));
require("@popperjs/core");
var menu_1 = __importDefault(require("../utils/menu"));
var Wrapper = function (_a) {
    var sortable = _a.sortable, onDragEnd = _a.onDragEnd, children = _a.children;
    if (sortable) {
        return (react_1.default.createElement(react_beautiful_dnd_1.DragDropContext, { onDragEnd: onDragEnd },
            react_1.default.createElement(react_beautiful_dnd_1.Droppable, { droppableId: "boxes" }, function (provided) { return (react_1.default.createElement("ul", __assign({ ref: provided.innerRef }, provided.droppableProps),
                children,
                provided.placeholder)); })));
    }
    return (react_1.default.createElement("ul", null, children));
};
var ItemWrapper = function (_a) {
    var sortable = _a.sortable, id = _a.id, index = _a.index, children = _a.children;
    if (sortable) {
        return (react_1.default.createElement(react_beautiful_dnd_1.Draggable, { draggableId: id.toString(), index: index, isDragDisabled: false }, function (provided) { return (react_1.default.createElement("li", __assign({ ref: provided.innerRef }, provided.draggableProps),
            react_1.default.createElement("div", __assign({ className: "ui-menu-handle" }, provided.dragHandleProps)),
            children)); }));
    }
    return (react_1.default.createElement("li", null, children));
};
var Menu = function (_a) {
    var open = _a.open, trigger = _a.trigger, options = _a.options, onClose = _a.onClose, onClick = _a.onClick, className = _a.className, scrollbar = _a.scrollbar, sortable = _a.sortable, onSort = _a.onSort, _b = _a.placement, placement = _b === void 0 ? 'bottom-start' : _b, _c = _a.fallbackPlacement, fallbackPlacement = _c === void 0 ? 'top-start' : _c;
    var _d = __read((0, react_1.useState)(false), 2), showMenu = _d[0], setShowMenu = _d[1];
    var popperRef = (0, react_1.useRef)(null);
    var _e = (0, react_popper_1.usePopper)(trigger, popperRef.current, {
        placement: placement,
        modifiers: [
            {
                name: 'flip',
                options: {
                    fallbackPlacements: [fallbackPlacement],
                },
            },
            {
                name: "offset",
                enabled: true,
                options: {
                    offset: [0, 4],
                },
            },
        ],
    }), styles = _e.styles, attributes = _e.attributes, update = _e.update;
    (0, react_1.useEffect)(function () {
        if (open && update) {
            update();
        }
        setShowMenu(open);
    }, [open, update]);
    var ref = (0, useClickOutside_1.default)(onClose);
    var handleOnDragEnd = function (result) {
        if (!result.destination)
            return;
        var newSortedOptions = Array.from(options);
        var _a = __read(newSortedOptions.splice(result.source.index, 1), 1), draggedItem = _a[0];
        newSortedOptions.splice(result.destination.index, 0, draggedItem);
        if (onSort) {
            onSort(newSortedOptions);
        }
    };
    return (react_1.default.createElement("div", { className: "ui-theme ui-menu", ref: ref },
        react_1.default.createElement("div", __assign({ ref: popperRef, className: (0, classnames_1.default)("ui-menu-popper", scrollbar && "ui-menu-scrollbar", className), style: __assign(__assign({}, styles.popper), { display: open ? 'block' : 'none', visibility: showMenu ? 'visible' : 'hidden' }) }, attributes.popper),
            react_1.default.createElement(Wrapper, { sortable: sortable, onDragEnd: handleOnDragEnd }, options.map(function (o, i) {
                var optionId = (0, menu_1.default)(o, i);
                return (react_1.default.createElement(ItemWrapper, { key: optionId, id: optionId, index: i, sortable: sortable }, o.divider ? (react_1.default.createElement("hr", { className: "menu-divider" })) : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("button", { className: (0, classnames_1.default)("menu-item", o.disabled && "disabled"), onClick: function () {
                            onClick(o, i);
                            if (update) {
                                update();
                            }
                        } },
                        o.leadingIcon ? (react_1.default.createElement(Icon_1.default, { icon: o.leadingIcon, className: (0, classnames_1.default)("ui-menu-item-icon-left", o.className ? o.className : ""), size: "small" })) : null,
                        react_1.default.createElement("span", { className: "ui-menu-label" }, o.label),
                        o.trailingIcon ? (react_1.default.createElement(Icon_1.default, { icon: o.trailingIcon, className: "ui-menu-item-icon-right", size: "small" })) : null,
                        (o.checked || o.unchecked) && (react_1.default.createElement("span", { className: "ui-menu-check" },
                            react_1.default.createElement("label", { className: "ui-menu-check-label" }, o.checkInfo),
                            react_1.default.createElement("input", { type: "checkbox", className: "ui-menu-checkbox", checked: o.checked }))))))));
            })))));
};
exports.default = Menu;
